import React from "react";


export default function Quantity(props){

    const [quantity, setQuantity] = React.useState(props.oldQty);

    React.useEffect(() => {
        setQuantity(props.oldQty);
    }, [props.oldQty]);

    React.useEffect(() => {

        if(props.setCurrentQuantity){
            props.setCurrentQuantity(quantity)
        }
        props.onHandle(props.id, quantity);




    }, [quantity]);
    
    return(
        <div className={`flex items-center h-11 w-36 ${props.style}`}>
           {props.label ? <label className="w-full text-sm font-semibold text-gray-700 mb-1">{props.label}</label> : null}
            <div className="flex flex-row h-full w-full rounded-full border border-gray-200 overflow-hidden">
                <button
                    onClick={() => quantity > 1 ? setQuantity(q => q - 1) : null}
                    className="flex items-center justify-center w-10 h-full text-gray-500 hover:text-brownSkin hover:bg-gray-50 transition-colors duration-150"
                >
                    <span className="text-lg leading-none">−</span>
                </button>
                <span className="flex items-center justify-center flex-1 text-sm font-semibold text-gray-800 select-none">
                    {quantity}
                </span>
                <button
                    onClick={() => setQuantity(q => q + 1)}
                    className="flex items-center justify-center w-10 h-full text-gray-500 hover:text-brownSkin hover:bg-gray-50 transition-colors duration-150"
                >
                    <span className="text-lg leading-none">+</span>
                </button>
            </div>
        </div>
    )
}